import { makeAutoObservable } from "mobx";
import { IShipment } from "../shipment.types";
import { SHIPMENT_STATUS_ENUM, SHIPMENT_STATUS_TRANSLATION_KEYS_MAP } from "../../manage-returns/rma-page/rma-types";
import { RETURN_METHOD_TYPES_MAP } from "../../return-methods/constants";

class ShipmentItemStore {
    private _model: IShipment;

    constructor(model: IShipment) {
        makeAutoObservable(this, {}, { autoBind: true });
        this._model = ensureValidModelCopy(model);
    }

    public get id(): number { return this._model.id; }
    public get returnId(): string { return this._model.return_id; }
    public get status(): SHIPMENT_STATUS_ENUM | null{ return this._model.status; }
    public get statusTranslationKey(): string { return SHIPMENT_STATUS_TRANSLATION_KEYS_MAP[this._model.status]; }
    public get returnLabelUrl(): string | null { return this._model.return_label_url; }
    public get trackingNumber(): string | null { return this._model.tracking_number; }
    public get trackingUrl(): string | null { return this._model.tracking_url; }
    public get customerState(): string { return this._model.customer_state; }
    public get customerCountry(): string { return this._model.customer_country; }
    public get carrier(): string { return this._model.carrier; }
    public get qrImageUrl(): string | null { return this._model.qr_image_url; }
    public get shippingConnectionId(): number | null { return this._model.shipping_connection_id; }
    public get externalId(): string { return this._model.external_id; }
    public get createDate(): string | null { return this._model.created_at; }
    public get lastUpdated(): string | null { return this._model.updated_at; }
    public get returnMethodType(): string | undefined { return RETURN_METHOD_TYPES_MAP[this._model.return_method?.type ?? this._model.product_case?.[0]?.return_method?.type as keyof typeof RETURN_METHOD_TYPES_MAP]?.label }
    public get customerId(): string | undefined { return this._model.rma_data?.customer_case?.customer_id; }
    public get customerUrl(): string | null { return this._model._customerUrl; }
    public get labelCost(): number | null { return this._model.label_cost; }
    public get orderNumber(): string | undefined { return this._model.rma_data?.customer_case?.order_name; }
    public get orderUrl(): string | null { return this._model._orderUrl; }
    public get paymentCurrencyCode(): string | null { return this._model.label_cost_currency; }
}

function ensureValidModelCopy(data: IShipment): IShipment {
    return {
        ...data,
        status: Number(data.status) as SHIPMENT_STATUS_ENUM,
    };
}

export default ShipmentItemStore; 